import React, { useState, useEffect } from "react";
import './NeonButtons.css';

const AgeRestrictionPage = ({ children }) => {
  const [ageVerified, setAgeVerified] = useState(false);

  useEffect(() => {
    // Check if the user has already verified their age
    const isAgeVerified = localStorage.getItem("ageVerified");
    if (isAgeVerified === "true") {
      setAgeVerified(true);
    }
  }, []);

  const handleVerifyAge = () => {
    localStorage.setItem("ageVerified", "true"); // Save the age verification
    setAgeVerified(true);
  };

  const handleDeclineAge = () => {
    alert("This website contains adult content and nudity. If you are not over 18 years old (21 in some locations) you are not allowed to go further. You must be of legal age to access this content.");
    window.location.href = "https://www.google.com"; // Redirect to another page
  };

  if (ageVerified) {
    // If the user has verified their age, show the content
    return <>{children}</>;
  }

  // Show the age restriction warning
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
        textAlign: "center",
        flexDirection: "column",
		width: "100vw",
		margin: "0 auto",
      }}
    >
      <h2 id="source-link">Age Restricted Content</h2>
      <em>This website contains adult content and nudity.</em>
	  <em>If you are not over 18 years old (21 in some locations) you are not allowed to go further.</em>
	  <em>You must be of legal age to access this content.</em>
      <div style={{ marginTop: "20px" }}>
		<div className="button-container">
		  <a href="#" className="neon-button"
			onClick={handleVerifyAge}
			>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			I am 18 or older
		  </a>
		  <a href="#" className="neon-button"
		  onClick={handleDeclineAge}
		  >
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			I am under 18
		  </a>
		</div>
      </div>
    </div>
  );
};

export default AgeRestrictionPage;